import React, {Component} from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import ReactDataSheet from 'react-datasheet';
import 'react-datasheet/lib/react-datasheet.css';
import { getSavedSimulations, updateSentimentSettings, updateWordCloudSettings, updateIndustryThemeSettings } from '../../../actions/dataAction';
import styled from 'styled-components';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faTrash from '@fortawesome/fontawesome-free-solid/faTrashAlt';
import { BoxButton } from '../../StyledComponents';

const SentimentHistory = styled.div`
  position: relative;
  height: 300px;
  overflow: scroll;
  background: #dfdfdf;
  padding: 5px;
  font-size: 12px;
`

const SentimentReports = styled.div`
  position: relative;
  height: 300px;
  overflow: scroll;
  padding: 5px;
  font-size: 12px;

  & .data-grid {
    min-width: 100%;
  }

  & .value-viewer {
    text-align: left;
    padding: 2px;
  }
`

const Frequency = styled.span `
  float: right;
`

const TrashBin = styled(FontAwesomeIcon)`
    margin-left:10px;
`;

const NavTabs = styled.a `
  margin-bottom: 5px;

  &:hover {
    text-decoration: none !important;
  }
`

const TabButton = styled.a `
  padding: 5px;
  font-size: 12px;
  text-decoration: none;

  &:hover {
    text-decoration: none !important;
  }

  & .active {
    background: #dfdfdf;
  }
`

const defaultRowSentiment = [{value:  "", type: "param"}, {value:  "", type: "keyword"}, {type:"hint", value: ""}, {type:"weight", value: "20"}];
const defaultRowWordCloud = [{value:  "", type: "param"}, {value:  "", type: "keyword"}, {type:"weight", value: "20"}];
const defaultRowIndustryThemes = [{value:  "", type: "param"}, {type:"weight", value: "20"}];

/*
const defaultGrid = [
  [{value:  "price", type: "param"}, {value:  "Support", type: "keyword"}, {type:"hint", value: "Felsökning"}, {type:"weight", value: "70"}],
  [{value:  "price", type: "param"}, {value:  "Support", type: "keyword"}, {type:"hint", value: "Trasig"}, {type:"weight", value: "30"}],
  [{value:  "price", type: "param"}, {value:  "Support", type: "keyword"}, {type:"hint", value: "Hjälp"}, {type:"weight", value: "40"}],
  [{value:  "price", type: "param"}, {value:  "Support", type: "keyword"}, {type:"hint", value: "Lagg"}, {type:"weight", value: "60"}],
  [{value:  "price", type: "param"}, {value:  "Tillbehör", type: "keyword"}, {type:"hint", value: "Mobilskal"}, {type:"weight", value: "70"}],
  [{value:  "price", type: "param"}, {value:  "Tillbehör", type: "keyword"}, {type:"hint", value: "Laddare"}, {type:"weight", value: "30"}],
  [{value:  "price", type: "param"}, {value:  "Tillbehör", type: "keyword"}, {type:"hint", value: "Skydd"}, {type:"weight", value: "40"}],
  [{value:  "price", type: "param"}, {value:  "Tillbehör", type: "keyword"}, {type:"hint", value: "USB-kabel"}, {type:"weight", value: "60"}],
  [{value:  "price", type: "param"}, {value:  "Roamingavgifter", type: "keyword"}, {type:"hint", value: "Nordamerika"}, {type:"weight", value: "70"}],
  [{value:  "price", type: "param"}, {value:  "Roamingavgifter", type: "keyword"}, {type:"hint", value: "Data"}, {type:"weight", value: "30"}],
  [{value:  "price", type: "param"}, {value:  "Roamingavgifter", type: "keyword"}, {type:"hint", value: "Resa"}, {type:"weight", value: "40"}],
  [{value:  "price", type: "param"}, {value:  "Roamingavgifter", type: "keyword"}, {type:"hint", value: "Surfkostnader"}, {type:"weight", value: "60"}],
  [{value:  "preference", type: "param"}, {value:  "Support", type: "keyword"}, {type:"hint", value: "Felsökning"}, {type:"weight", value: "110"}],
  [{value:  "preference", type: "param"}, {value:  "Support", type: "keyword"}, {type:"hint", value: "Trasig"}, {type:"weight", value: "80"}],
  [{value:  "preference", type: "param"}, {value:  "Support", type: "keyword"}, {type:"hint", value: "Hjälp"}, {type:"weight", value: "90"}],
  [{value:  "preference", type: "param"}, {value:  "Support", type: "keyword"}, {type:"hint", value: "Lagg"}, {type:"weight", value: "40"}],
  [{value:  "preference", type: "param"}, {value:  "Tillbehör", type: "keyword"}, {type:"hint", value: "Mobilskal"}, {type:"weight", value: "70"}],
  [{value:  "preference", type: "param"}, {value:  "Tillbehör", type: "keyword"}, {type:"hint", value: "Laddare"}, {type:"weight", value: "30"}],
  [{value:  "preference", type: "param"}, {value:  "Tillbehör", type: "keyword"}, {type:"hint", value: "Skydd"}, {type:"weight", value: "69"}],
  [{value:  "preference", type: "param"}, {value:  "Tillbehör", type: "keyword"}, {type:"hint", value: "USB-kabel"}, {type:"weight", value: "60"}],
  [{value:  "preference", type: "param"}, {value:  "Roamingavgifter", type: "keyword"}, {type:"hint", value: "Nordamerika"}, {type:"weight", value: "70"}],
  [{value:  "preference", type: "param"}, {value:  "Roamingavgifter", type: "keyword"}, {type:"hint", value: "Data"}, {type:"weight", value: "175"}],
  [{value:  "preference", type: "param"}, {value:  "Roamingavgifter", type: "keyword"}, {type:"hint", value: "Resa"}, {type:"weight", value: "120"}],
  [{value:  "preference", type: "param"}, {value:  "Roamingavgifter", type: "keyword"}, {type:"hint", value: "Surfkostnader"}, {type:"weight", value: "80"}],
];
*/

const defaultGrid = [
  [{value:  "price", type: "param"}, {value:  "Demo", type: "keyword"}, {type:"hint", value: "Demo"}, {type:"weight", value: "70"}],
];

const defaultGridWordCloud = [
  [{value:  "price", type: "param"}, {value:  "sample", type: "keyword"}, {type:"weight", value: "20"}]
]

const defaultGridIndustryThemes = [
  [{value:  "Demo", type: "param"}, {type:"weight", value: "20"}]
]

class SentimentFiltering extends Component {
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  resetData() {
    this.props.updateSentimentSettings(defaultGrid) && this.forceUpdate();
  }

  resetWordCloudData() {
    this.props.updateWordCloudSettings(defaultGridWordCloud) && this.forceUpdate();
  }

  resetIndustryThemeData() {
    this.props.updateIndustryThemeSettings(defaultGridIndustryThemes) && this.forceUpdate();
  }

  render() {
    const { user, data } = this.props;

    if (!user.client) {
      return null;
    }

    let words = data && data.variableData && data.variableData.sentimentData;
    words = words && _.orderBy(words, ['freq'],['desc']);

    if (!Array.isArray(user.client.sentimentSettings)) {
      this.props.updateSentimentSettings(defaultGrid);
    }

    if (!Array.isArray(user.client.wordCloudSettings)) {
      this.props.updateWordCloudSettings(defaultGridWordCloud);
    }

    let gridData = (user.client && user.client.sentimentSettings && Array.isArray(user.client.sentimentSettings) && user.client.sentimentSettings) || defaultGrid;
    let wordCloudGridData = (user.client && user.client.wordCloudSettings && Array.isArray(user.client.wordCloudSettings) && user.client.wordCloudSettings) || [];
    let industryThemesGridData = (user.client && user.client.industryThemeSettings && Array.isArray(user.client.industryThemeSettings) && user.client.industryThemeSettings) || [];

    const columns = [{name:"Parameter"},{name:"Keyword"},{name:"Hint"},{name:"Size"}]
    const wordCloudColumns = [{name:"Parameter"},{name:"Keyword"},{name:"Size"}]
    const industryThemeColumns = [{name:"Keyword"},{name:"Size"}]

    return (
      <div className="row">

        <nav>
          <NavTabs className="nav nav-tabs" id="nav-tab" role="tablist">
            <TabButton className="nav-item nav-link active" id="nav-keyfocus-tab" data-toggle="tab" href="#nav-keyfocus" role="tab" aria-controls="nav-keyFocus" aria-selected="true">Key focus</TabButton>
            <TabButton className="nav-item nav-link" id="nav-wordclouds-tab" data-toggle="tab" href="#nav-wordclouds" role="tab" aria-controls="nav-wordclouds" aria-selected="false">Wordclouds</TabButton>
            <TabButton className="nav-item nav-link" id="nav-industry-themes-tab" data-toggle="tab" href="#nav-industryThemes" role="tab" aria-controls="nav-industryThemes" aria-selected="false">Industry themes</TabButton>
          </NavTabs>
        </nav>

        <div className="col-md-6">
          <div className="tab-content" id="nav-tabContent">

            <div className="tab-pane fade active in" id="nav-keyfocus" role="tabpanel" aria-labelledby="nav-home-tab">
              <SentimentReports>
                <h5>Key focus</h5>
                <ReactDataSheet
                  data={gridData}
                  valueRenderer={(cell) => cell.value}
                  sheetRenderer={props => (
                      <table className={props.className + ' my-awesome-extra-class'}>
                          <thead>
                              <tr>
                                {columns.map(col => (<th>{col.name}</th>))}
                                <th className='action-cell' />
                              </tr>
                          </thead>
                          <tbody>
                              {props.children}
                          </tbody>
                      </table>
                    )}
                  rowRenderer={props => (
                      <tr>
                          {props.children}
                          <td className='cell' width="30" style={{maxWidth:'30px', textAlign:'center'}}>
                            <TrashBin icon={faTrash} onClick={(e) => gridData.splice(props.row, 1) && this.forceUpdate()}/>
                          </td>
                      </tr>
                    )}
                  onCellsChanged={(changes, arrayOfAdditions) => {
                    let grid = gridData.map(row => [...row])
                    changes.forEach(({cell, row, col, value}) => {
                      grid[row][col] = {...grid[row][col], value}
                    })
                    /*
                    if (arrayOfAdditions) {
                      grid.push(arrayOfAdditions);
                    }*/

                    this.props.updateSentimentSettings(grid);

                    //this.setState({grid})
                  }}
                />



              </SentimentReports>
                <BoxButton dark onClick={() => gridData.push(defaultRowSentiment) && this.forceUpdate()}>Add row</BoxButton>
                <BoxButton dark onClick={() => this.resetData()}>Reset data</BoxButton>

            </div>

            {/* WORDCLOUDS */}

            <div className="tab-pane fade" id="nav-wordclouds" role="tabpanel" aria-labelledby="nav-profile-tab">
              <SentimentReports>
                <h5>Wordclouds</h5>
                <ReactDataSheet
                  data={wordCloudGridData}
                  valueRenderer={(cell) => cell.value}
                  sheetRenderer={props => (
                      <table className={props.className + ' my-awesome-extra-class'}>
                          <thead>
                              <tr>
                                {wordCloudColumns.map(col => (<th>{col.name}</th>))}
                                <th className='action-cell' />
                              </tr>
                          </thead>
                          <tbody>
                              {props.children}
                          </tbody>
                      </table>
                    )}
                  rowRenderer={props => (
                      <tr>
                          {props.children}
                          <td className='cell' width="30" style={{maxWidth:'30px', textAlign:'center'}}>
                            <TrashBin icon={faTrash} onClick={(e) => wordCloudGridData.splice(props.row, 1) && this.forceUpdate()}/>
                          </td>
                      </tr>
                    )}
                  onCellsChanged={(changes, arrayOfAdditions) => {
                    let grid = wordCloudGridData.map(row => [...row])
                    changes.forEach(({cell, row, col, value}) => {
                      grid[row][col] = {...grid[row][col], value}
                    })
                    /*
                    if (arrayOfAdditions) {
                      grid.push(arrayOfAdditions);
                    }*/

                    this.props.updateWordCloudSettings(grid);

                    //this.setState({grid})
                  }}
                />

              </SentimentReports>
              <BoxButton dark onClick={() => wordCloudGridData.push(defaultRowWordCloud) && this.forceUpdate()}>Add row</BoxButton>
              <BoxButton dark onClick={() => this.resetWordCloudData()}>Reset data</BoxButton>
            </div>

            {/* INDUSTRY THEMES */}

            <div className="tab-pane fade" id="nav-industryThemes" role="tabpanel" aria-labelledby="nav-profile-tab">
              <SentimentReports>
                <h5>Industry themes</h5>
                <ReactDataSheet
                  data={industryThemesGridData}
                  valueRenderer={(cell) => cell.value}
                  sheetRenderer={props => (
                      <table className={props.className + ' my-awesome-extra-class'}>
                          <thead>
                              <tr>
                                {industryThemeColumns.map(col => (<th>{col.name}</th>))}
                                <th className='action-cell' />
                              </tr>
                          </thead>
                          <tbody>
                              {props.children}
                          </tbody>
                      </table>
                    )}
                  rowRenderer={props => (
                      <tr>
                          {props.children}
                          <td className='cell' width="30" style={{maxWidth:'30px', textAlign:'center'}}>
                            <TrashBin icon={faTrash} onClick={(e) => industryThemesGridData.splice(props.row, 1) && this.forceUpdate()}/>
                          </td>
                      </tr>
                    )}
                  onCellsChanged={(changes, arrayOfAdditions) => {
                    let grid = industryThemesGridData.map(row => [...row])
                    changes.forEach(({cell, row, col, value}) => {
                      grid[row][col] = {...grid[row][col], value}
                    })
                    /*
                    if (arrayOfAdditions) {
                      grid.push(arrayOfAdditions);
                    }*/

                    this.props.updateIndustryThemeSettings(grid);

                    //this.setState({grid})
                  }}
                />

              </SentimentReports>
              <BoxButton dark onClick={() => industryThemesGridData.push(defaultRowIndustryThemes) && this.forceUpdate()}>Add row</BoxButton>
              <BoxButton dark onClick={() => this.resetIndustryThemeData()}>Reset data</BoxButton>
            </div>


          </div>
        </div>
        <div className="col-md-6">
          <SentimentHistory>
            {words && words.map((word, index) => (
              <div key={index}>
                <span>{word.word}</span> <Frequency>{word.freq}</Frequency>{/* <TrashBin icon={faTrash} onClick={(e)=> this.deleteWord(word, "positive")}/>*/}
              </div>
            ))}
          </SentimentHistory>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    data: state.data
  };
}

export default connect(mapStateToProps, { getSavedSimulations, updateSentimentSettings, updateWordCloudSettings, updateIndustryThemeSettings })(SentimentFiltering);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/SentimentFiltering.js